/**
 * @flow
 * @relayHash 53104901eceec80ff398b5e6b188a699
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ArticleSelector_viewer$ref = any;
export type queries_blockAddFormQueryVariables = {||};
export type queries_blockAddFormQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ArticleSelector_viewer$ref
  |}
|};
export type queries_blockAddFormQuery = {|
  variables: queries_blockAddFormQueryVariables,
  response: queries_blockAddFormQueryResponse,
|};
*/


/*
query queries_blockAddFormQuery {
  viewer {
    ...ArticleSelector_viewer
    id
  }
}

fragment ArticleSelector_viewer on Viewer {
  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {
    articles {
      id
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_blockAddFormQuery",
  "id": null,
  "text": "query queries_blockAddFormQuery {\n  viewer {\n    ...ArticleSelector_viewer\n    id\n  }\n}\n\nfragment ArticleSelector_viewer on Viewer {\n  articlesForSelector: articlesPaginate(page: 1, pageSize: 5, hidden: false) {\n    articles {\n      id\n      title\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_blockAddFormQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ArticleSelector_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_blockAddFormQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articlesForSelector",
            "name": "articlesPaginate",
            "storageKey": "articlesPaginate(hidden:false,page:1,pageSize:5)",
            "args": [
              {
                "kind": "Literal",
                "name": "hidden",
                "value": false,
                "type": "Boolean"
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 5,
                "type": "Int"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v0
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4756398d3165215b6d6629caf68809df';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_blockAddFormQuery.graphql.js